import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {environment} from '../../../environments/environment';
import {
    IPolicy,
    IPublishPolicyResult,
    IPublishPolicyTranslation,
    Policy,
} from '../../features/legal/domain/policy';
import {IPolicyKey, PolicyKey} from '../../features/legal/domain/policy-key';
import {EntityList, IEntityList} from '../../wappy/domain/entity-list';
import {ApiService} from './api.service';

@Injectable({providedIn: 'root'})
export class ApiPoliciesService extends ApiService {
    private readonly url = `${environment.api.baseUrl}/policies`;

    getLatestByKey(key: string, languageCode?: string): Observable<Policy> {
        const encodedKey = encodeURIComponent(key);
        const url = languageCode
            ? `${this.url}/latest/${encodedKey}?lang=${encodeURIComponent(languageCode)}`
            : `${this.url}/latest/${encodedKey}`;
        return this.get<IPolicy>(url).pipe(
            map(policy => new Policy(policy)),
        );
    }

    getAll(filters: string | null = null): Observable<EntityList<Policy>> {
        const url = filters
            ? `${this.url}?filterBase64=${encodeURIComponent(filters)}`
            : this.url;
        return this.get<IEntityList<IPolicy>>(url).pipe(
            map(result => new EntityList<Policy>({
                items: result.items.map(policy => new Policy(policy)),
                totalRows: result.totalRows ?? 0,
            })),
        );
    }

    getKeys(): Observable<PolicyKey[]> {
        return this.get<IPolicyKey[]>(`${this.url}/keys`).pipe(
            map(keys => keys.map(key => new PolicyKey(key))),
        );
    }

    publish(
        key: string,
        translations: IPublishPolicyTranslation[],
    ): Observable<IPublishPolicyResult> {
        return this.post<IPublishPolicyResult>(this.url, {
            key,
            translations,
        });
    }

    acceptTerms(): Observable<void> {
        return this.post<void>(
            `${this.url}/app_terms/accept`,
            {},
        );
    }
}
